jQuery(document).ready(function($) {
  //best collections slider
  const bestCollection = new Swiper('.best-collections-slider', {
    speed: 400,
    slidesPerView: 3,
    spaceBetween: 24,
    scrollbar: {
      el: ".collections-scrollbar",
      hide: false,
    },

    navigation: {
      nextEl: ".collection-button-next",
      prevEl: ".collection-button-prev",
    },
    pagination: {
      el: ".collection-pagination",
    },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        // when window width is >= 480px
        768: {
          slidesPerView: 2,
        },
        // when window width is >= 640px
        992: {
          slidesPerView: 3,
        }
      }
  });

  const pricingSlider = new Swiper('.pricing-slider', {
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 0,
    initialSlide: 1,
    centeredSlides: false,
    navigation: {
      nextEl: ".pricing-button-next",
      prevEl: ".pricing-button-prev",
    },
      breakpoints: {
        992: {
          slidesPerView: 3,
          initialSlide: 2,
        }
      }
  });

  const reviewsSlider = new Swiper('.reviews-slider', {
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 44,
    navigation: {
      nextEl: ".review-button-next",
      prevEl: ".review-button-prev",
    },
    pagination: {
      el: ".review-pagination",
    },
      breakpoints: {
        992: {
          slidesPerView: 3,
        }
      }
  });

  //show layers
  $('.all-layers').hover(function () {
    var layerNumber = $(this).data('layer');
    $('.layer-r').hide();
    $('.layer-' + layerNumber).show();
  });


  //show hide mobile
  $(".close-menu").click(function() {
    $('.mobile-menu').hide();
  });

  $(".menu-button").click(function() {
    $('.mobile-menu').show();
  });

  //count numbers
  var scrollFlag = false;

    $(window).scroll(function () {
      if (!scrollFlag) {
        if ($('.happy-customers-h').length) {
          if (isScrolledIntoView($(".happy-customers-h"))) {
              startCountup();
              scrollFlag = true;
          }
        }
      }
    });

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = elem.offset().top;
      return elemTop <= docViewBottom;
    }


  // $(document).ready(function () {
  //   startCountup();
  // });

  function startCountup() {
      $(".count-numbers").each(function () {
          var countElement = $(this);
          var targetCount = countElement.data("count");

          $({ countNum: 0 }).animate(
              {
                  countNum: targetCount,
              },
              {
                  duration: 1000, // Adjust the duration as needed
                  easing: "linear",
                  step: function () {
                      countElement.text(formatNumber(Math.floor(this.countNum)));
                  },
                  complete: function () {
                      countElement.text(formatNumber(targetCount));
                  },
              }
          );
      });
  }

  function formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  //single page slider
  var singleProductBottom = new Swiper(".single-product-slider-bottom", {
      spaceBetween: 40,
      slidesPerView: 4,
      watchSlidesProgress: true,
    });
    var singleProductTop = new Swiper(".single-product-slider-top", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".single-product-next",
        prevEl: ".single-product-prev",
      },
      thumbs: {
        swiper: singleProductBottom,
      },
    });

  const transfomrLiving = new Swiper('.transform-living-slider', {
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 50,
    navigation: {
      nextEl: ".single-product-next",
      prevEl: ".single-product-prev",
    },
    pagination: {
      el: ".transform-living-pagination",
    },
      breakpoints: {
        992: {
          slidesPerView: 4,
        }
      }
  });
  

});